var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('message-loading'),_c('message-loading',{attrs:{"is-right":true}}),_c('message-loading'),_c('message-loading',{attrs:{"is-right":true}}),_c('message-loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }